<template>
    <MainLayout selectMenu="20-1">
        <div v-if="!hasAuth">
            <NoAuth></NoAuth>
        </div>
        <div v-else class="register-container">
            <!-- Card 1: 产品序列号 -->
            <Card class="section-card" dis-hover>
                <div slot="title" class="card-title">产品序列号</div>
                <div class="section-body">
                    <div class="input-row">
                        <Input v-model="serialNumber" size="large" class="section-input" />
                        <Button type="warning" size="small" @click="copySerialNumber" class="inline-btn">复制</Button>
                    </div>
                    <div class="action-row">
                        <Button type="success" icon="ios-camera-outline" @click="openScanner">扫码</Button>
                        <Button type="warning" icon="ios-image-outline" @click="triggerFileUpload">上传图片识别</Button>
                        <input
                            ref="fileInput"
                            type="file"
                            accept="image/*"
                            style="display: none"
                            @change="handleFileUpload"
                        />
                    </div>
                </div>
            </Card>

            <!-- Card 2: 激活设备类型 -->
            <Card class="section-card" dis-hover>
                <div slot="title" class="card-title">激活设备类型</div>
                <div class="section-body">
                    <div class="tag-group">
                        <span
                            v-for="item in chkList"
                            :key="item.id"
                            class="device-tag"
                            :class="{ 'tag-checked': levelBit[item.id] }"
                            @click="toggleDevice(item.id)"
                        >{{ item.name }}</span>
                    </div>
                    <div class="tag-toggle">
                        <Button size="small" type="text" @click="toggleSelectAll">
                            {{ checkAll ? '取消全选' : '全选' }}
                        </Button>
                    </div>
                </div>
            </Card>

            <!-- Card 3: 激活码 -->
            <Card class="section-card" dis-hover>
                <div slot="title" class="card-title">激活码</div>
                <div class="section-body">
                    <div class="generate-row">
                        <Button type="primary" size="large" long icon="md-key" @click="createFromSerialNumber" class="generate-btn">生成激活码</Button>
                    </div>
                    <div class="input-row">
                        <Input v-model="registrationCode" size="large" :placeholder="getTranslation('u089')" class="section-input" />
                        <Button type="warning" size="small" @click="copyRegistrationCode" class="inline-btn">复制</Button>
                    </div>
                    <div class="action-row">
                        <Button type="success" @click="resetRegisterCode">还原序列号</Button>
                    </div>
                </div>
            </Card>

            <!-- 扫码弹窗 -->
            <Modal v-model="scanModalVisible" title="扫码识别" :width="420" footer-hide class-name="scan-modal" @on-visible-change="onModalVisibleChange">
                <div v-if="scanModalVisible" class="scanner-wrapper">
                    <qrcode-stream
                        :key="scannerKey"
                        ref="qrReader"
                        @decode="onDecode"
                        @init="onInit"
                        :paused="paused"
                    />
                    <Button type="warning" long @click="closeScanner">关闭摄像头</Button>
                </div>
            </Modal>
        </div>
    </MainLayout>
</template>

<script>
import MainLayout from '@/components/MainLayout.vue'
import NoAuth from '@/components/NoAuth.vue'
import { mapGetters } from 'vuex'
import { API_URL } from '@/constants/const.js'
import axios from 'axios'
import { postJsError } from '@/util/util.js'
import { QrcodeStream } from 'vue-qrcode-reader'
import jsQR from 'jsqr'

export default {
    name: 'RegisterCreate',
    components: {
        MainLayout,
        NoAuth,     
        QrcodeStream,
    },
    props: {},
    data() {
        return {
            hasAuth: true,
            macAddress: '',
            serialNumber: '',
            registrationCode: '',
            scanModalVisible: false,
            scannerKey: 0,
            paused: true,
            chkList:[
                {'id':0,'name':'HRC-803中频焊机'},
                {'id':1,'name':'HRC-802'},
                {'id':2,'name':'HRC-A50'},
                {'id':3,'name':'HRC-501'},
                {'id':4,'name':'HRC-650焊接质量监控仪'},
                {'id':5,'name':'HRC-670铆接质量监控仪'},
                {'id':6,'name':'HRC-62交流焊机'}],
            levelBit:[true],
        }
    },
    computed: {
        ...mapGetters(['getTranslation']),
        checkAll() {
            return this.chkList.every(item => this.levelBit[item.id])
        },
    },
    mounted() { },
    created() {
        this.setBreadcrumbItems()
        this.getData()
    },
    methods: {
        async getData() {
            const url = API_URL['registerInit']
            const res = await axios.get(url
            ).catch((err) => {
                postJsError(err)
            })
            if (res && res.data && res.data.code === 200) {
                
                this.macAddress = res.data.data.mac || '';
                this.hasAuth = true;
            } else if (res && res.data && res.data.code == 3001) {
                this.hasAuth = false;
            } else if (res && res.data && res.data.msg) {
                this.$Message.error(res.data.msg);
            } else {
                this.$Message.error(this.getTranslation('c001'));
            }
        },
        setBreadcrumbItems() {
            if (this.$lang && this.$lang['u085']) {
                this.$store.commit('setBreadcrumbItems', [
                    { title: this.getTranslation('u085') }
                ])
            }            
        },
        copySerialNumber() {
            if (!this.serialNumber) return
            navigator.clipboard.writeText(this.serialNumber)
                .then(() => {
                    this.$Message.success(this.getTranslation('u091'))
                })
                .catch(() => {
                    this.$Message.error(this.getTranslation('u092'))
                })
        },
        copyRegistrationCode() {
            if (!this.registrationCode) return
            navigator.clipboard.writeText(this.registrationCode)
                .then(() => {
                    this.$Message.success(this.getTranslation('u091'))
                })
                .catch(() => {
                    this.$Message.error(this.getTranslation('u092'))
                })
        },
        createFromMac() {
            if (!this.macAddress) {
                this.$Message.error("请填写MAC地址");
                return;
            }
          
            let data = new FormData();
            data.append("type", "fromMac");
            this.postRegistrationData(data);
        },
        createFromSerialNumber() {            
            if(this.levelBit.length ==0 || this.levelBit.filter(r=>{return r;}).length == 0){
                this.$Message.error("请选择激活设备类型");
                return 
            }
            let data = new FormData();
            data.append("type", "fromSerialNumber");
            this.postRegistrationData(data);
        },
        resetRegisterCode() {
            if (!this.registrationCode) {
                this.$Message.error("请输入激活码");
                return;
            }
            let data = new FormData();
            data.append("type", "reset");
            this.postRegistrationData(data);
        }, 
        postRegistrationData(data) {
            data.append("macAddress", this.macAddress);           
         
            data.append("serialNumber", this.serialNumber);
            data.append("registrationCode", this.registrationCode);
            data.append("levelBit", this.levelBit.join(","));
            const url = API_URL['registerCreate']
            axios.post(url, data
            ).then((res) => {
                if (res && res.data && res.data.code === 200) {
                    if( data.get("type") === "fromMac") {
                        this.serialNumber = res.data.data.serialNumber || '';
                        this.registrationCode = res.data.data.registrationCode || '';
                        this.$Message.success("产品序列号和激活码生成成功");
                    } else if(data.get("type") === "fromSerialNumber") {
                        this.registrationCode = res.data.data.registrationCode || '';
                        this.$Message.success("激活码生成成功");
                    } else if(data.get("type") === "reset") {
                        this.serialNumber = res.data.data.serialNumber || '';
                        this.levelBit = res.data.data.levelBit || [];
                        this.macAddress = res.data.data.macAddress || '';
                        this.$Message.success("序列号还原成功");
                    }
                } else if (res && res.data && res.data.msg) {
                    this.$Message.error(res.data.msg);
                } else {
                    this.$Message.error(this.getTranslation('c001'));
                }
            }).catch((err) => {
                postJsError(err)
            })
        },
        toggleSelectAll() {
            const newValue = !this.checkAll
            this.chkList.forEach((item) => {
                this.$set(this.levelBit, item.id, newValue)
            })
        },
        toggleDevice(id) {
            this.$set(this.levelBit, id, !this.levelBit[id])
        },
        openScanner() {
            this.scannerKey++
            this.paused = true
            this.scanModalVisible = true
        },
        closeScanner() {
            this.paused = true
            this.scanModalVisible = false
        },
        onModalVisibleChange(visible) {
            if (!visible) {
                this.paused = true
            }
        },
        triggerFileUpload() {
            this.$refs.fileInput.click()
        },
        handleFileUpload(event) {
            const file = event.target.files[0]
            if (!file) return
            const reader = new FileReader()
            reader.onload = (e) => {
                const img = new Image()
                img.onload = async () => {
                    let result = null

                    // 方案1：BarcodeDetector API（原生系统级扫码，Chrome/Edge 83+，
                    //        Android 调用 Google ML Kit，识別率对标微信）
                    if ('BarcodeDetector' in window) {
                        try {
                            const detector = new window.BarcodeDetector({ formats: ['qr_code'] })
                            const barcodes = await detector.detect(img)
                            if (barcodes.length > 0) {
                                result = barcodes[0].rawValue
                            }
                        } catch (e) {
                            console.log('BarcodeDetector failed, fallback to jsQR:', e)
                        }
                    }

                    // 方案2：jsQR 回退（预处理 + 多级缩放）
                    if (!result) {
                        result = this.decodeQrWithJsQR(img)
                    }

                    if (result) {
                        this.serialNumber = result
                        this.$Message.success('识别成功')
                    } else {
                        this.$Message.warning('未识别到二维码')
                    }
                }
                img.src = e.target.result
            }
            reader.readAsDataURL(file)
            // 重置 input，允许重复选择同一文件
            event.target.value = ''
        },
        // 图像预处理：灰度化 + 对比度增强 + 锐化，提升 jsQR 对模糊图片的识别率
        preprocessForQR(imageData) {
            const data = imageData.data
            const len = data.length
            // 1. 灰度化 + 对比度拉伸
            for (let i = 0; i < len; i += 4) {
                // 加权灰度值 (感知亮度)
                const gray = 0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2]
                // 对比度拉伸：让亮的更亮，暗的更暗
                let v = (gray - 128) * 1.8 + 128
                v = v < 0 ? 0 : v > 255 ? 255 : v
                data[i] = data[i + 1] = data[i + 2] = v
                // alpha 保持不变
            }
            // 2. 简易锐化：用拉普拉斯算子增强边缘（遍历内部像素）
            const w = imageData.width
            const h = imageData.height
            const copy = new Uint8ClampedArray(data)
            for (let y = 1; y < h - 1; y++) {
                for (let x = 1; x < w - 1; x++) {
                    const idx = (y * w + x) * 4
                    // 拉普拉斯 3x3 核: [0,-1,0, -1,5,-1, 0,-1,0]
                    const c = copy[idx]
                    const t = copy[idx - w * 4]
                    const b = copy[idx + w * 4]
                    const l = copy[idx - 4]
                    const r = copy[idx + 4]
                    let v = 5 * c - t - b - l - r
                    v = v < 0 ? 0 : v > 255 ? 255 : v
                    data[idx] = data[idx + 1] = data[idx + 2] = v
                }
            }
        },
        // jsQR 回退方案：多级缩放 + 预处理
        decodeQrWithJsQR(img) {
            const scales = [2, 1.5, 3]
            for (const scale of scales) {
                const canvas = document.createElement('canvas')
                canvas.width = img.width * scale
                canvas.height = img.height * scale
                const ctx = canvas.getContext('2d')
                ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
                const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height)
                this.preprocessForQR(imageData)
                const code = jsQR(imageData.data, imageData.width, imageData.height)
                if (code && code.data) {
                    return code.data
                }
            }
            return null
        },
        onDecode(result) {
            if (!result) return
            this.paused = true
            this.serialNumber = String(result).trim()
            this.$Message.success('扫码成功')
            this.scanModalVisible = false
        },
        async onInit(promise) {
            try {
                await promise
                // 相机就绪后才开始扫码
                this.paused = false
            } catch (error) {
                let msg = '摄像头初始化失败'
                if (error && error.name === 'NotAllowedError') {
                    msg = '请允许浏览器访问摄像头'
                } else if (error && error.name === 'NotFoundError') {
                    msg = '未检测到可用摄像头'
                } else if (error && error.name === 'NotSupportedError') {
                    msg = '当前页面环境不支持摄像头扫码，请使用 HTTPS 或 localhost'
                }
                this.$Message.error(msg)
                this.closeScanner()
            }
        }
    },


}
</script>

<style scoped>
@import url('../../assets/style/list.css');
@import url('../../assets/style/tab.css');

/* ===== 容器 ===== */
.register-container {
    max-width: 780px;
    margin: 0 auto;
    padding: 12px;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

/* ===== 分组卡片 ===== */
.section-card {
    border-radius: 10px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    background: #fff;
}

.section-card .card-title {
    font-size: 15px;
    font-weight: 600;
    color: #17233d;
    padding-left: 4px;
    border-left: 3px solid #2d8cf0;
}

.section-body {
    padding: 4px 0;
}

/* ===== 输入行 ===== */
.input-row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 12px;
}

.input-row .section-input {
    flex: 1;
}

.inline-btn {
    flex-shrink: 0;
    border-radius: 4px;
}

/* ===== 操作按钮行 ===== */
.action-row {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
}

.generate-row {
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #e8eaec;
}

.generate-btn {
    border-radius: 6px !important;
    font-size: 15px !important;
    font-weight: 600 !important;
    letter-spacing: 2px;
    background: linear-gradient(135deg, #2d8cf0 0%, #19be6b 100%) !important;
    border: none !important;
    box-shadow: 0 4px 16px rgba(45, 140, 240, 0.35);
    transition: all 0.3s ease;
}

.generate-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 24px rgba(45, 140, 240, 0.5);
    background: linear-gradient(135deg, #5cadff 0%, #3ed38d 100%) !important;
}

.action-row .ivu-btn {
    border-radius: 4px;
    transition: all 0.2s ease;
}

.action-row .ivu-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.12);
}

/* ===== 设备标签组 ===== */
.tag-group {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 8px;
}

.device-tag {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 7px 16px;
    border-radius: 20px;
    border: 1.5px solid #dcdee2;
    background: #f8f8f9;
    color: #515a6e;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    user-select: none;
    transition: all 0.2s ease;
    white-space: nowrap;
}

.device-tag:hover {
    border-color: #2d8cf0;
    color: #2d8cf0;
    background: #f0f5ff;
}

.device-tag.tag-checked {
    border-color: #2d8cf0;
    background: #2d8cf0;
    color: #fff;
    box-shadow: 0 2px 8px rgba(45, 140, 240, 0.3);
}

.tag-toggle {
    padding-top: 4px;
}

/* ===== 扫码弹窗 ===== */
.scanner-wrapper {
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: center;
}

.scanner-wrapper video {
    width: 100%;
    max-width: 360px;
    border-radius: 8px;
    background: #000;
}

/* ===== 响应式 ===== */

/* 平板 */
@media (max-width: 1199px) {
    .register-container {
        max-width: 100%;
        padding: 10px;
        gap: 12px;
    }

    .device-tag {
        padding: 6px 14px;
        font-size: 13px;
    }
}

/* 手机 */
@media (max-width: 767px) {
    .register-container {
        padding: 8px;
        gap: 10px;
    }

    .section-card .card-title {
        font-size: 14px;
    }

    /* 输入行：手机端 Input + 复制按钮堆叠 */
    .input-row {
        flex-direction: column;
        gap: 8px;
    }

    .input-row .section-input {
        width: 100%;
    }

    .inline-btn {
        align-self: flex-end;
    }

    /* 操作按钮：手机端全宽 */
    .action-row {
        flex-direction: column;
    }

    .action-row .ivu-btn {
        width: 100%;
        min-height: 44px;
        font-size: 14px;
        justify-content: center;
    }

    /* 标签：更大触控区域 */
    .device-tag {
        padding: 10px 18px;
        font-size: 14px;
        min-height: 44px;
    }

    .tag-group {
        gap: 8px;
    }

    /* 弹窗手机端适配 */
    .scan-modal >>> .ivu-modal {
        width: 95vw !important;
        margin: 0 auto;
    }

    .scanner-wrapper video {
        max-width: 100%;
    }
}

/* 桌面大屏 */
@media (min-width: 1200px) {
    .register-container {
        max-width: 780px;
    }
}
</style>
